import DocumentInterface from './DocumentInterface';
import DocumentTable from './DocumentTable';
import {
    DocumentSectionProvider
} from '../knowledgeBuilderContext/DocumentSectionContext';

/**
 * This component contains the components that would involve the documents
 * @component
 * @returns {React.JSX}
 */
export default function DocumentSection() {
    return (
        <DocumentSectionProvider>
            <div className="p-3 flex flex-col flex-grow h-0">
                <DocumentInterface/>
                <DocumentTable/>
            </div>
        </DocumentSectionProvider>
    );
}